import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import HomeIndex from './Home/HomeIndex';
import TamimaIndex from './Tamima/TamimaIndex';
import CharactersIndex from './Characters/CharactersIndex';
import ContactusIndex from './Contactus/ContactusIndex';
import RoadmapIndex from './Roadmap/RoadmapIndex';
import WhitepaperIndex from './Whitepaper/WhitepaperIndex';
import Manager from './Admin';
import BlogsIndex from './Blogs/BlogsIndex';
import Auth from './Auth';
import BlogSingle from './Blogs/components/Single';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route exact path={'/'} element={<Layout />}>
          <Route exact path="" element={<HomeIndex />} />
          <Route exact path="roadmap" element={<RoadmapIndex />} />
          <Route exact path="whitepaper" element={<WhitepaperIndex />} />
          <Route exact path="tamima" element={<TamimaIndex />} />
          <Route exact path="creatures" element={<CharactersIndex />} />
          <Route exact path="blogs" element={<BlogsIndex />} />
          <Route exact path="blogs/:id" element={<BlogSingle />} />
          <Route exact path="contactus" element={<ContactusIndex />} />
        </Route>
        <Route path={'/auth'} element={<Auth />}/>
        <Route path={'/manager'} element={<Manager />}/>
        <Route path="*" element={<Navigate replace to="/" />} />
     </Routes>
   </Router>
  );
}